// extracted by mini-css-extract-plugin
module.exports = {"linkList":"LinkList_linkList__CmYmy","link":"LinkList_link__s2tgi"};